import placements from './../Placements';
import prependProtocol from './prependProtocol';
const getAnchorTarget = (brazeTarget) => {
    switch (brazeTarget) {
        case 'BLANK':
            return '_blank';
        case 'SELF':
            return '_self';
        default:
            return '_self';
    }
};
const destructure = (placement, payload) => {
    switch (placement) {
        case placements.PRESCREEN: {
            const { extras, imageUrl, buttons, triggerId: campaignId, uri: messageUrl, clickAction: messageClickAction, openTarget, isHTML, message, } = payload;
            const hasButton = buttons && buttons.length > 0;
            const { buttonColor, template, mobile_image_url: mobileImageURL, removeCrossIcon, } = extras;
            const { uri: buttonUrl, text, clickAction: buttonClickAction, } = buttons.length > 0
                ? (hasButton && buttons[1]) || {}
                : (hasButton && buttons[0]) || {};
            return {
                buttons,
                campaignId,
                // We always prefer the button-Settings as the Braze interface doesn't
                // show the message- Setting anymore if you add a Button.
                messageUrl: prependProtocol(buttonUrl || messageUrl),
                messageClickAction: buttonClickAction || messageClickAction,
                buttonText: text,
                buttonColor,
                imageUrl,
                openTarget: getAnchorTarget(openTarget !== null && openTarget !== void 0 ? openTarget : 'SELF'),
                hasButton,
                isHTML,
                message,
                template,
                mobileImageURL,
                removeCrossIcon,
            };
        }
        case placements.TEASER: {
            const { imageUrl, url, linkText, id: campaignId, extras: { openTarget }, } = payload;
            return {
                campaignId,
                url: prependProtocol(url),
                linkText,
                imageUrl,
                openTarget: getAnchorTarget(openTarget !== null && openTarget !== void 0 ? openTarget : 'BLANK'),
            };
        }
        case placements.SLIDE_UP: {
            const { uri: url, duration: messageDuration, dismissType, triggerId: campaignId, message, clickAction, openTarget, imageUrl, extras: { button_text: buttonText }, } = payload;
            return {
                url,
                campaignId,
                messageDuration,
                dismissType,
                message,
                clickAction,
                openTarget: getAnchorTarget(openTarget !== null && openTarget !== void 0 ? openTarget : 'SELF'),
                imageUrl,
                buttonText,
            };
        }
        default:
            return payload;
    }
};
export default destructure;
//# sourceMappingURL=destructure.js.map